import React from 'react';
import classNames from 'classnames';

const SubMenuJira = (props) => {
  return (
    <ul className="collapse multi-collapse" id="integracao-jira">
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraCreateIssue',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-create-issue"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-create-issue"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraCreateIssue')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraCreateIssue',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Criar Novo ticket"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_create_request-1.svg"
            alt=""
          />
          <p>Novo Ticket</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListProjects',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-create-issue"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-list-projects"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListProjects')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListProjects',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Listar Projetos"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_request-1.svg"
            alt=""
          />
          <p>Listar Projetos</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListRequestypes',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-request-types"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-request-types"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListRequestypes')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListRequestypes',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Tipos de tickets"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_request-1.svg"
            alt=""
          />
          <p>Tipos tickets</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListStatus',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-list-status"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-list-status"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListStatus')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListStatus',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Listar Status"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_request-1.svg"
            alt=""
          />
          <p>Listar Status</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListIssues',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-list-issues"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-list-issues"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListIssues')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListIssues',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Listar Tickets"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_request-1.svg"
            alt=""
          />
          <p>Listar Tickets</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraShowIssue',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-show-issue"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-show-issue"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraShowIssue')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraShowIssue',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Mostrar uma Requisição"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_show_request.svg"
            alt=""
          />
          <p>Checar Ticket</p>
        </label>
      </li>
      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListPriorities',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-request-types"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-request-types"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListPriorities')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListPriorities',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Listar prioridades"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_request-1.svg"
            alt=""
          />
          <p>Listar Prioridades</p>
        </label>
      </li>

      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraListComments',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-list-comments"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-list-comments"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraListComments')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraListComments',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Listar comentários"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_list_comments.svg"
            alt=""
          />
          <p>Listar Comentários</p>
        </label>
      </li>

      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraInsertComment',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-insert-comment"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-insert-comment"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraInsertComment')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraInsertComment',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Inserir novo Comentário"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_insert_comment-1.svg"
            alt=""
          />
          <p>Inserir Comentário</p>
        </label>
      </li>

      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraAttachFile',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-attach-file"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-attach-file"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraAttachFile')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraAttachFile',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Anexar um arquivo"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_attach_file-1.svg"
            alt=""
          />
          <p>Anexar Arquivo</p>
        </label>
      </li>

      <li>
        <span
          className={classNames({
            'd-none': props.draggingType !== 'JiraUpdateStatusIssue',
            'dragging-overlay': true,
          })}
          style={{ height: 82 }}
        />
        <input
          id="radio_avancado--jira-update-status-issue"
          type="radio"
          name="radio_blocos_padrao"
        />
        <label
          htmlFor="radio_avancado--jira-update-status-issue"
          draggable
          onDragStart={(e) => props.handleDragStart(e, 'JiraUpdateStatusIssue')}
          onDragEnd={(e) => props.handleDragEnd(e)}
          className={classNames({
            dragging: props.draggingType === 'JiraUpdateStatusIssue',
          })}
        >
          <img
            src="/assets/images/icons/icon_hint.svg"
            className="hint"
            data-toggle="tooltip"
            data-placement="right"
            title="Atualizar Status do ticket"
            alt=""
          />
          <img
            className="no-drag"
            src="/assets/images/icons/builder/icon_update_status.svg"
            alt=""
          />
          <p>Finalizar Ticket</p>
        </label>
      </li>
    </ul>
  );
};
export default SubMenuJira;
